
export class CreateAccount {
    acceptedTerms: boolean;
    city: string;
    cityId: string;
    company: string;
    companyName: string;
    countryCode: string;
    email: string;
    id: string;
    name: string;
    password: string;
    phone: string;
    planId: string;
    position: string;
    profile: string;
    role: string;
    abntCommunicator: boolean = false;
}